export const english = {
  jan: "Jan",
  feb: "Febr",
  mar: "Mar",
  apr: "Apr",
  may: "May",
  jun: "Jun",
  jul: "Jul",
  aug: "Aug",
  sep: "Sep",
  oct: "Oct",
  nov: "Nov",
  dec: "Dec",
  next: "Next",
  welcomeToSoloPlat: "Welcome to Sologenic!",
  alreadyHaveAccount: "I already have a CoinField account",
  haveAccount: "Already have a CoinField Account?",
  letsCreate: "Create Your CoinField Account",
  letsCreateSolo: "Let's Create a Sologenic Account",
  withoutAccount: "I don't have an account yet",
  assetsOnCF: "Assets shown are held on CoinField’s platform",
  emailConfirmed: "Your email has been confirmed",
  signIn: "Sign In",
  done: "Done",
  enterEmail: "Enter your e-mail",
  enterVerCode: "Enter your verification code",
  enterOtp: "Enter your 2FA code",
  login: "Log In",
  searchLabel: "Search",
  searchAdvLabel: "Advanced",
  applyNow: "Apply Now",
  currentAccount: "Current Account",
  from: "From",
  cfWallet: "CoinField Wallet",
  soloWallet: "Sologenic Wallet",
  email: "Email",
  dateOfBirth: "Date of Birth",
  signedInAs: "Signed in as",
  address: "Address",
  occupation: "Occupation",
  jobTitle: "Job Title",
  timezone: "Time Zone",
  defaultCurrency: "Default Currency",
  language: "Language",
  accountStatements: "Account Statements",
  availableBalance: "Available Balance",
  locked: "Locked",
  notEnoughFunds: "Not Enough Funds",
  to: "To",
  pending: "Pending",
  balance: "Balance",
  selectOne: "Select one",
  selectLanguage: "Select Language",
  theme: "Theme",
  currency: "Currency",
  pending: "Pending",
  deposit: "Deposit",
  withdraw: "Withdraw",
  transfer: "Transfer",
  cryptoTransfer: "Convert & Transfer",
  history: "History",
  statements: "Statements",
  summary: "Summary",
  optAllRegions: "All Regions",
  optAsia: "Asia",
  optEuro: "Europe",
  optOceania: "Oceania",
  optNorth: "North America",
  optSouth: "South America",
  optUSA: "USA",
  allExchanges: "All Exchanges",
  cancel: "Cancel",
  continue: "Continue",
  confirmTrade: "Confirm Trade",
  buyWith: "Buy with",
  privacyPolicy: "Privacy Policy",
  termsAndConditions: "Terms & Conditions",
  sellFor: "Sell for",
  signInCopy:
    "CoinField is a fully-regulated European- based cryptocurrency exchange serving 193 countries worldwide. Log in now to start trading",
  signUp: "Sign Up",
  signUpCopy:
    "If you don’t have an existing CoinField account, sign up here to access CoinField Exchange.",
  signUpCopyS:
    "If you don’t have an existing CoinField or Sologenic account, sign up here to access the Sologenic platform",
  loginCopy: "Login to your account",
  usernamePlaceholder: "Enter your email address",
  passwordPlaceholder: "Enter your password",
  createPW: "Create your password",
  enterNewPass: "Enter new password",
  confirmNewPass: "Confirm new password",
  confPW: "Confirm your password",
  haveRefCode: "Have referral code?",
  readTerms:
    "I have read and agree with the <a target='_blank' rel='noopener noreferrer' href='{termsUrl}'>terms and conditions</a> and <a target='_blank' rel='noopener noreferrer' href='{privacyUrl}'>privacy policy</a>.",
  otpPlaceholder: "Enter your 2FA (if enabled)",
  forgotPassword: "Forgot Password?",
  noAccount: "No Account?",
  assetsTokenized: "Assets Tokenized",
  menuTrade: "Trade",
  menuPortfolio: "Portfolio",
  menuSettings: "Settings",
  menuDex: "DEX",
  menuOrders: "Orders",
  menuSupport: "Support",
  menuHistory: "History",
  stocksAll: "All",
  stocksPopular: "Most Popular",
  stocksFavorite: "Favorites",
  stocksRecent: "Most Recent",
  stocksGain: "Top Gain",
  stocksLoss: "Top Loss",
  stocksLocation: "Location",
  stocksTableMarket: "Market",
  stocksTableExchange: "Exchange",
  stocksTableCurrency: "Currency",
  stocksTableChange: "Change (24h)",
  stocksTableBuy: "Buy Price",
  stocksTableSell: "Sell Price",
  stockSearchPH: "Search Ticker symbol",
  singleStockOpen: "OPEN",
  singleStockOpensIn: "Opens in:",
  searchComponentPlaceholder: "Search for Stock, ETF, etc",
  exchangeCatAll: "All",
  exchangeCatStocks: "Stocks",
  exchangeCatEtf: "ETFs",
  exchangeCatComm: "Commodities",
  exchangeCatCfd: "CFD",
  exchangeCatFx: "Fx",
  exchangeSingCatStocks: "Stock",
  exchangeSingCatEtf: "ETF",
  exchangeSingCatComm: "Commodity",
  exchangeSingCatCfd: "CFD",
  exchangeSingCatFx: "Fx",
  exchangeCatAllTypes: "All Types",
  allExchanges: "All Exchanges",
  buy: "buy",
  sell: "sell",
  browseByExchange: "Browse by Exchange",
  expand: "Expand",
  exit: "Exit",
  collapse: "Collapse",
  searchTickerSymbol: "Search Ticker symbol",
  searchExchange: "Search Exchange",
  filterRegions: "Filter Region",
  filterExchange: "Filter Exchange",
  filterAsset: "Filter Asset",
  filterOpen: "Filter Open",
  filterDate: "Filter Date Range",
  filterStatus: "Filter Status",
  lastPrice: "Last Price",
  change: "Change",
  bidSize: "Bid/Size",
  askSize: "Ask/Size",
  high: "High",
  low: "Low",
  volume: "Volume",
  conversionByCF: "Your crypto conversion is being executed on ",
  stock: "Stock",
  cfd: "CFD",
  tradeOptPool: "Pool-Order",
  tradeOptMarket: "Market",
  tradeOptLimit: "Limit",
  tradeOptStopLimit: "Stop-Limit",
  tradeOptStop: "Stop",
  tradeOptmarket: "Market",
  tradeOptlimit: "Limit",
  tradeOptstop: "Stop",
  poolOrderInfo:
    "This is a pool-order. Once the pool-order reaches 1, the people who's contributed to the pool will have their fraction distributed.",
  contributors: "Contributors",
  avgContribution: "Avg. Contribution",
  share: "Share",
  "tradeOptstop-limit": "Stop-Limit",
  amountTo: "Amount to",
  transactionType: "Order Type",
  assetType: "Asset Type",
  spend: "spend",
  receive: "receive",
  enterAmount: "Enter Amount",
  timeInForce: "Time in Force Policy",
  limitPrice: "Limit Price",
  stopPrice: "Stop Price",
  tradeDisclaimer:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  portValue: "Portfolio Value (Estimated)",
  soloAssets: "Sologenic Assets",
  cfAssets: "CoinField Assets",
  cfFiatWallets: "Your CoinField Fiat Wallets",
  cfCryptoWallets: "Your CoinField Crypto Wallets",
  soloFiatWallets: "Your Sologenic Wallets",
  openOrders: "Open Orders",
  fullOrders: "Fulfilled Orders",
  dexTitle: "Decentralized Exchange",
  launchDex: "Launch Dex",
  manageTrustlines: "Manage Trustlines",
  addTrustline: "Add Trustline",
  newBalance: "New Balance",
  asset: "Asset",
  amount: "Amount",
  selectOne: "Select one",
  feePercent: "Fee Percent",
  enterYourOtp: "Enter your 2FA Code",
  otpRequired: "Two-factor Authentication Required",
  feeAmount: "Fee Amount",
  amountToReceive: "Amount Transferred",
  confirmTransfer: "Confirm Transfer",
  address: "Address",
  status: "Status",
  leverage: "Leverage",
  actions: "Actions",
  investType: "Investment Type",
  allocations: "Allocations",
  sendCode: "Send code",
  verificationNotice:
    "A verification code has been sent to {user_email}. The code will automatically expire after 15 minutes.",
  verificationNotice2: "A verification code has been sent to {user_email}. ",
  noEmailReceived: "Resend the code",
  enterRefCode: "Enter Referral Code",
  checkInbox: "Check your inbox",
  starterAccountApproved: "Your Demo Account has been Approved!",
  starterAccountApprovedS: "Your Practise Account has been Approved!",
  startTrading: "Start Trading",
  startUnlocked: "You've Unlocked:",
  upgradeToUnlock: "Upgrade to Pro Account & Unlock:",
  upgradeToUnlockS: "Upgrade to Live Trading & Unlock:",
  upgradeToPro: "Upgrade to Pro",
  wait5minutes: "Wait 5 minutes before you can request another code.",
  proInfo:
    "ID Documents, Proof of address, Selfie and a Video interview may be required.",
  unlock1: "Access to account Dashboard (view mode)",
  unlock2: "Access to referral program",
  unlock3: "Ability to manage Favorite Markets List",
  unlock4: "Access to Price Alerts",
  unlock5: "Trade, withdraw and deposit are disabled",
  unlock1S: "Practice funds to test drive the Sologenic platform",
  unlock2S: "Market, Limit and Pool orders practice",
  unlock3S: "Access to all features in Live Account",
  unlock4S: "Managing favourite markets list",
  unlock5S: "Tutorial and FAQ",
  proUnlock1: "Ability to trade with crypto and fiat",
  proUnlock2: "Deposit limit of up to $2M USD per day",
  proUnlock3: "Withdrawal limit of up to $2M USD per day",
  proUnlock4: "Free Airdrops & Rewards (when applicable)",
  proUnlock5: "Access to API",
  proUnlock1S: "Monitor over 40,000 assets",
  proUnlock2S: "Real-time quotes",
  proUnlock3S: "Access to 30 global stock exchanges",
  proUnlock4S: "Professional charting tools",
  proUnlock5S: "Market, Limit and Stop Loss Orders",
  verifyYourPhone: "Let's Verify Your <b>Phone Number</b>",
  verify: "Verify",
  countryCode: "Country Code",
  enterPhone: "Enter your phone number",
  nationality: "Nationality",
  codeSentEmail: "Code sent",
  codeSent: "A verification code has been sent",
  numberInvalid: "Wrong format. Please check the phone number!",
  codeSentTo: "A verification code has been sent to <b>{number}</b>",
  enterVerificationCode: "Enter verification code",
  resendCode: "Resend code",
  phoneVerified: "Your phone number has been verified",
  tellUsAboutYou: "Tell Us About Yourself",
  typeName:
    "Type your name exactly as it appears in your Verification Documents.",
  countryOfResidence: "Country of Residence",
  fullName: "Full Name (as it appears on your ID)",
  firstName: "First Name",
  lastName: "Last Name",
  middleName: "Middle Name",
  dob: "Date of Birth",
  profileSubmitted: "Your information has been submitted",
  verifyIdentity: "Verify your <b>Identity</b>",
  verifySubtitle:
    "Please upload or take a selfie holding up your ID, and a piece of paper that reads:",
  verifyRequirements1: '"For CoinField"',
  verifyRequirements2: "Today's date",
  takePhoto: "Take Photo",
  uploadFile: "Upload File",
  uploadId: "Upload your <b>Identification</b>",
  browseFiles: "Browse Files",
  retakePhoto: "Retake",
  removePhoto: "Remove",
  chooseIssuingCountry: "Choose Issuing Country/region",
  deposAndWiths: "Deposits & Withdrawals",
  transfers: "Transfers",
  notiTransferSubmitted: "Transfer submitted",
  accType: "Account Type",
  profile: "Profile",
  security: "Security",
  documentCentre: "Document Centre",
  darkMode: "Dark Mode",
  docInfo:
    "Please only upload the documents you have been requested to upload by our support team. If you have any questions about how to upload your documents or the requirements please contact us at <a href='mailto:support@sologenic.com'>support@sologenic.com</a>",
  selectDocumentType: "Select Document Type",
  id: "ID",
  selfie: "Selfie",
  proofOfAddress: "Proof Of Address",
  example: "Here is an example",
  idTitle: "Please upload a photo of your Passport or Government Issued ID",
  poaTitle:
    "Please follow the below requirements to upload your proof of address",
  selfieTitle:
    "Please follow the below requirements to help our KYC officers verify your account.",
  idLi1: "All the characters and numbers in your ID must be visible",
  idLi2:
    "The photo must be taken with proper lighting clearly showing the details of your ID",
  idLi3: "The file you are uploading must be less 10MB in size",
  idLi4: "Files that are too low in resolution to be verified will be rejected",
  selfieLi1:
    'Hold a piece of paper that has: For CoinField, "today\'s date" & your signature matching your ID written on it.',
  selfieLi2:
    "The photo must be taken with proper lighting clearly showing your face and the details of your ID",
  selfieLi3: "The file you are uploading must be less 10MB in size",
  selfieLi4:
    "Files that are too low in resolution to be verified will be rejected",
  poaLi1: "The document must be less than 3 months old",
  poaLi2: "The document must state your full name, the date and your address",
  poaLi3:
    "Only the following types of documents are accepted: Water bill, Electricity bill, Internet bill, cable bill, phone bill & bank statements",
  idExampleTitle: "ID - Two sides required",
  passport: "Passport",
  driversLicense: "Driver's License",
  prcard: "PR Card",
  citizenshipcard: "Citizenship Card",
  healthcardphoto: "Health Card With Photo",
  nationalid: "National ID",
  socialserviceid: "Social Service ID",
  documentType: "Document Type",
  documentDate: "Expiry Date (YYYY/MM/DD)",
  documentNumber: "Document Number",
  frontOfID: "Front of your ID",
  passwordChanged: "Password changed",
  currentWrongPassword: "Current password is not correct",
  backOfID: "Back of your ID",
  dragAndDrop: "Drop the file OR click to browse",
  missingIDFields: "Some fields are missing",
  delete: "Delete",
  selfieInfo: "Save a copy of your selfie and upload it here",
  poaInfo: "Upload a copy of your document here",
  utility: "Utility Bill (Electricity, Water or Telecommunications)",
  taxDoc: "Tax Document",
  creditCard: "Credit Card Statement",
  bankStatement: "Bank Statement",
  docDate: "Document Date",
  idFrontUploaded: "Front ID File submitted",
  idBackUploaded: "Back ID File submitted",
  fileUploaded: "File(s) submitted",
  practiseAccount: "Practise",
  demoAccount: "Demo",
  liveTradingAccount: "Live Trading",
  proTradingAccount: "Pro",
  limitedAccount: "Limited",
  corporateAccount: "Corporate",
  finishVerification: "Finish Verification",
  practisePerk1: "Access to account dashboard (view mode)",
  practisePerk2: "Access to referral program",
  practisePerk3: "Ability to manage Favorite Markets List",
  practisePerk4: "Creating price alerts",
  practisePerk5: "Cutting edge security",
  practisePerk6: "24/7 Support",
  practisePerk1S: "Practice money to test drive the Sologenic platform",
  practisePerk2S: "Market, Limit and Pool orders practice",
  practisePerk3S: "Competitive trading fees",
  practisePerk4S: "Managing favourite markets list",
  practisePerk5S: "Tutorial and FAQ",
  liveTradingPerk1: "Ability to trade with crypto and fiat",
  liveTradingPerk2: "Competitive trading fees",
  liveTradingPerk3: "Exclusive Consierge Trading Desk and OTC Service",
  liveTradingPerk4: "Deposit limit of $2M USD per day",
  liveTradingPerk5: "Withdrawal limit of $2M USD per day",
  liveTradingPerk6: "24/7 Support",
  liveTradingPerk1S: "Monitor over 40,000 assets",
  liveTradingPerk2S: "Real-time quotes",
  liveTradingPerk3S: "Access to 30 global stock exchanges",
  liveTradingPerk4S: "Professional charting tools",
  liveTradingPerk5S: "Market, Limit and Stop Loss Orders",
  // liveTradingPerk6: "24/7 Support",
  limitedPerk1: "Ability to trade with crypto and fiat",
  limitedPerk2: "Competitive trading fees",
  limitedPerk3: "Cutting edge security",
  limitedPerk4: "Deposit limit of $10k USD per day",
  limitedPerk5: "Withdrawal limit of $10k USD per day",
  limitedPerk6: "24/7 Support",
  corporatePerk1: "VIP for special CoinField events & workshops",
  // corporatePerk2: "Ability to link multiple individual accounts",
  corporatePerk3: "Exclusive Consierge Trading Desk and OTC Service",
  corporatePerk4: "Competitive trading fees",
  corporatePerk5: "Ability to trade with crypto and fiat",
  corporatePerk6: "24/7 Support",
  emailVerification: "Email Verification",
  incorrect_captcha: "Incorrect Captcha",
  level0T: "Verify your email address",
  level0P:
    "Your email address hasn't been verified. Click on this button to continue verification.",
  level1T: "Your email address has been successfully verified",
  level1P:
    "Finish upgrading your account to <b>Pro Account</b> to enable trading and  daily withdrawals/deposits up to USD$2 million.",
  level2T:
    "Your email address and phone number have been successfully verified",
  level2P:
    "Finish upgrading your account to <b>Pro Account</b> to enable trading and daily withdrawals/deposits up to USD$2 million.",
  level3T: "There is a problem with your submitted documents",
  level3P:
    "Your account is pending Compliance Team manual check. Please allow us some time, we will get back to you over the email with successful verification or additional information request.",
  level4T: "Pending authentication by our KYC Team",
  level4P:
    "Your documents have been submitted and are currently being reviewed. <b>You will receive further instructions by email.</b> If you have not received any instructions, please contact our support team at <a href='mailto:compliance@sologenic.com'>compliance@sologenic.com</a>.",
  level5T: "Your account is almost fully verified",
  level5P:
    "Finish upgrading your account to <b>Pro Account</b> to enable daily withdrawals/deposits up to USD$2 million.",
  level6T: "Your account is fully verified",
  level6P: "You can withdraw and deposit up to $2 million USD per day!",
  jumioAcceptedT: "Your identity documents have been approved",
  jumioAcceptedP:
    "Your identity documents have been approved. You can continue to upgrade your account to Pro.",
  jumioProcessT: "Your identity have been successfully submitted",
  jumioProcessP:
    "Your identity documents are being reviewed. You can continue the process of verification.",
  level6pendingT: "Your profile is being reviewed",
  level6pendingP:
    "Your profile information, proof of address and experience information is being reviewed. You will receive a notification when there is a resolution.",
  sureToCancel:
    "Your account will still remain as Demo Account if you exit the verification process. <br>Are you sure you want to exit?",
  confirmation: "Sure to exit?",
  upgradeMessage: "You must upgrade your account to access this feature",
  upgradeAcc: "Upgrade Account",
  receiveMonthly: "Receive Monthly",
  disabled: "Disabled",
  disable: "Disable",
  enable: "Enable",
  twofactor: "2 Factor Authentication",
  password: "Password",
  changePassword: "Change Password",
  disable2fa: "Disable 2FA",
  typeToDisable:
    "Please type in your 6 digit 2FA code below in order to disable the 2FA security on your account.",
  warning: "Warning",
  warningContent:
    "By enabling the Two-Factor Authentication you are fully aware that if you lose the recovery code displayed on the next page, we are NOT able to help you retrieve it. This is due to our high security measures.",
  doItLater: "I'll do it later",
  understand: "I understand",
  imReady: "I'm ready",
  changingPassword: "Changing Password",
  oldPassword: "Current Password",
  newPassword: "New Password",
  confirmNewPassword: "Confirm New Password",
  otpDisabled: "Two Factor Authentication Disabled.",
  otpEnabled: "Two Factor Authentication Enabled.",
  wrongOtp: "Two Factor Authentication Code invalid",
  step1: "Step 1:",
  step2: "Step 2:",
  step3: "Step 3:",
  downloadGoogle: "Download and install the Google Authenticator App",
  clickYes: 'Click "I\'m ready"',
  scanCode:
    "Scan the QR Barcode on the next screen in your Google Authenticator App",
  note: "On the next page you will see a recovery code under the QR Code. This is your rescue code in case you lose your phone. Please be advised, if you lose the recovery code, we are not able to help you retrieve it. This is due to our high security measures.",
  typeToConfirmOtp:
    "Type in your 2FA code from your Google Authenticator App to finish activation",
  scanThis: "Scan this code",
  writeThis: "Write down this code",
  writeWarning:
    "Write down the following code somewhere safe. If you lose this code you will not be able to recover it.",
  copyCode: "Copy Code",
  copyToClipboard: "Code copied to clipboard",
  somethingWentWrong:
    "Something went wrong. Please, try again later. If problem persists, contact support",
  accActivity: "Account Activity",
  currentSign: "Current sign in",
  ipAddress: "IP Address",
  onlyOpen: "Display Open Exchange Only",
  date: "Date",
  time: "Time",
  previousSign: "Previous sign in",
  wrongActivity:
    "If you feel this is inaccurate or that your account may have been compromised, please get in touch with our support team immediately, either through the Support Center or by email at <a href='mailto:support@sologenic.com'>support@sologenic.com</a>",
  selectDepositOption: "Select Deposit Option:",
  ecommpay: "Credit or Debit Card",
  interac: "Interac E-Transfer",
  wire: "Wire Below",
  wirea: "Wire Above",
  eft: "EFT",
  muchbetter: "MuchBetter",
  sepa: "SEPA",
  amountToDeposit: "Amount to deposit",
  limitAmount: "Limit: Min {min} {currency} - Max {max} {currency} per day",
  transferFee: "Transaction Fee",
  youReceive: "You Receive",
  selectIDtype: "Select ID Type",
  idType: "ID type",
  identityCard: "Identity Card",
  typeInfo:
    "Use a valid government-issued photo ID. A residence permit is also a valid identity card",
  idcard: "ID Card",
  drivinglicense: "Driving License",
  passport: "Passport",
  frontDocument: "Front of document",
  backDocument: "Back of document",
  idFrontInstructions:
    "Center your document and take a photo. Make sure all details are clear.",
  idBackInstructions: "Turn over ID and take photo of the back",
  idUploadInstructions:
    "Make sure the document is completely visible on the file and is not pixelated",
  takePhoto: "Take Photo",
  frontDocumentPassport: "Passport",
  pleaseAllow: "Please allow us to access your camera OR choose Upload File",
  letsVerifyAddress: "Let's Verify Your Address",
  addressDetails: "Address Details",
  address1: "Address Line 1*",
  address2: "Address Line 2",
  city: "City/Town*",
  stateProvince: "State/Province/Region*",
  postalCode: "ZIP/Postal Code*",
  country: "Country",
  goToDocCentre: "Go to Docs Centre",
  goToTrading: "Go to Dashboard",
  docsRejected: "There is a problem with your account",
  docsRejectedInstructions:
    "Check your email inbox for more information or contact support at <a href='mailto:support247@coinfielc.om'>support@sologenic.com</a>",
  docsReviewing: "Your Documents are being reviewed!",
  docsReviewingInstructions:
    "Your documents have been received and are being reviewed. You will receive a notification when your application has been approved or if there are issues with your application. <br /><br />In the meantime, you can browse and see the platform.",
  goToDashboard: "Go to Dashboard",
  goToSettingsDash: "Go to Settings",
  tellUsExperience: "Tell Us About Your Experience",
  howSkills: "How would you describe the level of your trading skills?*",
  howMuch: "How much do you think you will trade per month?*",
  howFunds: "How did you accummulate your source of funds?*",
  enterJobTitle: "Enter Job Title",
  setUpCorporate: "Set up your Corporate Account today!",
  enterDetails: "Enter your business details below",
  businessDetails: "Business Details",
  businessAddress: "Business Address",
  furtherInfo: "Further Information",
  bankReference: "Bank Reference",
  enterDetailsDesc:
    "Please fill out each section of the following forms. The information you provide here is confidential and will only be used for our records. Please review your submission before you moving on to the next page as we require accurate details to help you quickly set up your institutional account",
  yes: "Yes",
  no: "No",
  api: "API",
  newApi: "New API Token",
  oneHour: "1 hour",
  oneDay: "24 hours",
  oneWeek: "7 days",
  oneYear: "1 year",
  tenYears: "10 years",
  withdrawals: "Withdrawals",
  deposits: "Deposits",
  orders: "Orders",
  wrongDate: "Invalid date. Please, check again.",
  expiration: "Expiration Time",
  generateApiKey: "Generate API Key",
  scopes: "API Scopes",
  otp: "Two-Factor Authentication Code",
  missingCaptcha: "Captcha Test Missing",
  myTokens: "My Tokens",
  revoke: "Revoke",
  keyIdentifier: "API Key Identifier",
  revoked: "Revoked",
  notAvailable: "N/A",
  active: "Active",
  expiry: "Expires at",
  missingFields: "There are some missing fields",
  revokedAt: "Revoked at",
  docs: "Document Centre",
  captchaEmpty: "Google ReCaptcha test is required.",
  tokenDisclaimer:
    "<b>DISCLAIMER:</b> By generating an API Key, you are fully aware that if you lose the above key, we are NOT able to help you retrieve it. This is due to our high security measures.",
  invalid_confirmation_code: "Verification Code Invalid",
  expired_confirmation_code: "Expired Verification Code",
  passResetTitle1: "Forgot your <b>Password</b>?",
  passResetTitle2: "Enter your <b>Verification Code</b>",
  passResetTitle3: "Create New <b>Password</b>",
  internationalName: "Full Name in English",
  passResetContent1:
    "Don’t worry, just enter the email address you registered with and we will send you a verification code to reset your password.",
  passResetContent2:
    "Please enter your verification code that we’ve sent to {email}. The code will automatically expire after 15 minutes.",
  passResetContent3: "Let’s create a new password",
  invalidEmail: "Enter a valid e-mail address",
  passwordsDontMatch: "Passwords don't match. Please, check again",
  passError:
    "Invalid! Password must be at least 6 characters long and include uppercase letters, lowercase letters and numbers",
  passwordChanged: "Password successfully reset",
  passRequirements:
    "Password must be at least 6 characters long and include uppercase letters, lowercase letters and numbers",
  _newToCf: "New to CoinField?",
  _newToSOLO: "New to Sologenic?",
  _stepsAway:
    "You are a few short steps away from trading confidently and securely. Start exploring the new economy with CoinField now!",
  _stepsAwaySolo:
    "You are a few short steps away from trading confidently and securely. Start exploring the new economy with Sologenic now!",
  logIn: "Log In",
  _haveAcc: "Already have an account?",
  _welcomeToSOLO: "Welcome to Sologenic!",
  _welcomeBack: "Welcome to CoinField!",
  _welcomeBackSolo: "Welcome to Sologenic!",
  _confieldIs:
    "CoinField is a fully-regulated European-based cryptocurrency exchange serving 193 countries worldwide.",
  _createAnAccount: "Create an account",
  submit: "Submit",
  confirm: "Confirm",
  _ipVerificationCopy:
    "We have detected a login to your account from new IP address. Please, check your inbox and submit the code you have received to continue.",
  _enterIpCode: "Enter confirmation code",
  _ipConfirmed: "Your IP address has been confirmed.",
  _usingForOther: "I'm not representing someone else.",
  _other: "Other",
  _accountId: "Account ID",
  _isPEP:
    "I'm not a Politically Exposed Person (nor you or your family are related to the government, a political party, a prominent public official, or high-rank member of an International Organization).",
  _purposeOfAcc: "Purpose of the account",
  specify: "Specify",
  _signOut: "Sign Out",
  _signingOut: "Signing Out",
  _sureToSignOut: "Are you sure to sign out?",
  _apiKey: "New API Key",
  _keyRevoked: "API Key successfully revoked",
  _welcomeToCF: "Welcome To CoinField!",
  _successUpload: "Successfully uploaded",
  login_success_notification:
    "Successful login. You are being redirected to Dashboard",
  _onReview: "Pending",
  _similarProfileT: "Profile Similarity",
  _similarProfileP:
    "The details you have entered are similar to an existing profile. Please go to Document Centre and upload a proof of identity document",
  _selectDocType: "Select a Document type",
  _secondaryIdT: "Secondary ID verification",
  _secondaryId: "Secondary ID",
  _secondaryIdP:
    "Your secondary ID document must be different to the one you have already uploaded",
  _documentDateIf: "Expiry Date (if applicable) YYYY/MM/DD",
  _or: "OR",
  _underageError: "User must be at least 18 years old",
  _invalidDateBefore: "Expiry date cannot be in the past",
  _invalidDateTomorrow: "Expiry date cannot be tomorrow",
  _invalidDateFuture: "Date cannot be in the future",
  _invalidDateTooOld: "Document cannot be older than 90 days",
  _invalidDateNot18: "User must be at least 18 years old",
  _fileTooBig: "File cannot be larger than 10MB",
  _invalidFileType: "Invalid file type.",
  _docTypeMissing: "Please, select a document type",
  _docType: "Document Type",
  _docExpiryDateMissing: "Expiry date required",
  _otpRequired:
    "Enable Two-Factor Authentication in order to generate API keys.",
  _404: "404",
  _notFound:
    "Unfortunately, the page does not exist. Please check the URL, or try one of the links below.",
  _tryLater: "Something went wrong! Try again later.",
  _demoST: "Access to account dashboard (view mode)",
  _limitedT: "Crypto-to-Crypto and Fiat-to-Crypto Trading",
  _proST: "Withdraw/deposit up to $2 million per day",
  _corpoST: "An account designed for corporations and businesses",
  _proRequired: "(Pro Account Required)",
  _documentDetails: "Document details",
  _goToSettings: "Go to Settings",
  _close: "Close",
  _copy: "Copy",
  _copied: "Copied",
  _specifyDocType: "Please, specify document type",
  _iReject: "Reject",
  _iAgree: "I agree",
  _newTerms: "Legal Update",
  _soloTerms: "Sologenic User Agreement & Privacy Policy",
  _uploading: "Uploading...",
  _iAcceptTerms:
    "I have read and agree with the <a href='https://coinfield.com/company/terms' target='_blank' rel='noopener noreferrer'>User Agreement.</a>",
  _iAcceptPrivacy:
    "I have read and agree with the <a href='https://coinfield.com/company/privacy' target='_blank' rel='noopener noreferrer'>Privacy Policy.</a>",
  _iAcceptSoloTerms:
    "I have read and agree with the <a href='https://sologenic.com/legal/user-agreement' target='_blank' rel='noopener noreferrer'>User Agreement.</a>",
  _iAcceptSoloPrivacy:
    "I have read and agree with the <a href='https://sologenic.com/legal/privacy-policy' target='_blank' rel='noopener noreferrer'>Privacy Policy.</a>",
  _termsChangedCopy:
    "We have made some changes to our existing  User Agreement & Privacy Policy. To continue to use our platform & service, we require all existing users to review the new <a href='https://coinfield.com/company/terms' target='_blank' rel='noopener noreferrer'>User Agreement</a> & <a href='https://coinfield.com/company/privacy' target='_blank' rel='noopener noreferrer'>Privacy Policy</a>. Please carefully read and agree to the terms. If you have any questions or concerns, you may contact our support team.",
  _soloTermsCopy:
    "To proceed with the Sologenic Asset Tokenization Platform you need to authorize that your CoinField user information is to be shared with Sologenic and agree with <a href='https://sologenic.com/legal/user-agreement' target='_blank' rel='noopener noreferrer'>User Agreement</a> and <a href='https://sologenic.com/legal/privacy-policy' target='_blank' rel='noopener noreferrer'>Privacy Policy</a>",
  sureToCancelCorporate: "Are you sure you want to exit?",
  _corporateT1: "Tell Us About <b>Your Business Details</b>",
  _corporateT2: "Tell Us About <b>Your Registered Address of Business</b>",
  _corporateT3:
    "You’re almost there, tell us some more about <b>Your Business</b>",
  _corporateT4: "Specify your <b>Business Bank details</b>",
  _corporateT5: "Enter your <b>Directors’ details</b>",
  _corporateT6: "Enter the <b>Beneficial Owners</b>",
  _corporateT7: "Upload the <b>Required Documents</b>",
  _corporateP1:
    "Please fill out each section of the following form. The information you provide here is confidential and will only be used for our records. Please review your submission before you moving on to the next step as we require accurate details to help you quickly set up your institutional account",
  _corporateP2:
    "Please enter the name, position, and address of each Director of your company  (up to 5). The information you provide here is confidential and will only be used for our records. The information you enter must be accurate. If your company changes Director, please inform us so we can update our records.",
  _corporateP3:
    "Please enter the name, position, and address of each Beneficial Owner who has more than 25% of shares in the company (up to 5). The information you provide here is confidential and will only be used for our records. The information you enter must be accurate. If your company changes Beneficial Owner, please inform us so we can update our records.",
  _corporateP4:
    "If you don’t have them all available at this time, you will be able to return to this page through “Account Type” tab on your personal settings page to finish uploading them when you are able to. <br><br> We do require all of the documents to approve your institutional account, so please get in touch with us if you have any questions or concerns so we can ensure your account gets created quickly.",
  _businessName: "Business name",
  _registrationNumber: "Registration number",
  _natureOfActivity: "Nature of business activity",
  _businessWebsite: "Company website",
  _emailInvalid: "Invalid email",
  _addressDetails: "Address Details",
  _addressLine: "Address Line",
  _city: "City",
  _territory: "State/Province/Prefecture/Region",
  zipcode: "ZIP/Postal Code",
  _whatSource: "What is your source of funds?",
  _branches:
    "Please specify the places of operation or if your company has branches located in foreign countries",
  _uploading: "Uploading",
  _tooManyRequests:
    "We're sorry, but you have sent many requests to us recently. Please try again later.",
  _legalFormLabel: "What is the legal form of your company?",
  _hasComplianceTeam: "Does your company have a compliance team?",
  _ifHasTeam: "If yes, please enter the size of the team",
  _hasContractualRepresentatives:
    "Does your company have contractual representatives?",
  _ifHasReps: "If yes, please specify the representative company's name",
  _hasConnectionsWithEstonia:
    "Does your company have connections with Estonia?",
  _purposeOfCorporate: "What is the purpose of your corporate account?",
  _provideServicesToEEA:
    "Does your company provide services to the European Economic Area or third countries?",
  _ifProvidesServices: "If yes, please specify the countries",
  _mostImportantVendors:
    "What are the most important business partners/vendors?",
  _optional: "Optional",
  _acceptCash: "Do you accept cash deposits in your business?",
  _shareholdersAbove25:
    "Are there any other shareholders owning over 25% of your business?",
  _ifShareholdersAbove25: "If yes, please enter full legal names",
  _bankDetailsCopy: "Please specify your current bank details",
  _bankName: "Bank Name",
  _bankAddress: "Address",
  _bankCity: "City",
  _bankState: "State/Province/Region/Prefecture",
  _bankZipcode: "ZIP/Postal Code",
  _bankCountry: "Country",
  _directorsDetails: "Director's details",
  _firstName: "First Name",
  _lastName: "Last Name",
  _address: "Address",
  _state: "State/Province/Region/Prefecture",
  _zipcode: "ZIP/Postal Code",
  _country: "Country",
  _remove: "Remove",
  _add: "Add",
  _position: "Position",
  first_name: "First Name",
  last_name: "Last Name",
  position: "Position",
  country: "Country",
  city: "City",
  state: "State/Province",
  zipcode: "ZIP/Postal Code",
  address: "Address",
  _ownerDetails: "Beneficial Owner’s Details",
  _certificate: "Certificate of Incorporation and Business Registration",
  _articles: "Articles of Association",
  _poaOfCorporation: "Proof of address of the Corporation",
  _companyReport:
    "An official company report which was issued within the last year, including a list of current Directors, a list of Ultimate Beneficial Owners and their percentage of holdings",
  _identifications:
    "Please upload one piece of Identification for each Beneficial Owner who is owning over 25% (Passport, Driving License or National ID card)",
  _employment: "Employment",
  _trading: "Trading",
  _inheritance: "Inheritance",
  _active_entrepreneur: "Active Entrepreneur",
  _former_entrepreneur: "Former Entrepreneur",
  _wealth_generated: "Wealth Generated (Savings)",
  _specify: "Specify",
  _soleProperty: "Sole proprietorship",
  _partnership: "Partnership",
  _corporation: "Corporation",
  _llc: "Limited Liability Company (LLC)",
  _publicCompany: "Public Company",
  _npo: "Non-Profit Organization",
  _investing: "Investing",
  _store_crypto: "Store crypto assets",
  _send_receive_crypto: "Send and receive crypto",
  _exampleUrl: "i.e https://example.com",
  _invalidUrlFormat: "Invalid URL format. i.e https://www.example.com",
  _finishApplication: "Finish Application",
  _corporateRejectedT: "Your application was rejected",
  _corporateRejectedP:
    "Check your email inbox for more information or contact support at <a href='mailto:support247@coinfielc.om'>support@sologenic.com</a>",
  _soloIs:
    "Sologenic is a tokenized asset trading platform. Log in or create a <b>Sologenic</b> account now.",
  _comingSoon: "Coming Soon",
  _continueSignup: "Continue to sign up",
  _creatingNewAcc: "Creating New <b>Account</b>?",
  _doYouKnow:
    "Do you know that you can log in using your existing <b>CoinField account?</b>",
  _logInWithCoinfield: "Log In With CoinField",
  _simTerms:
    "I understand that Sologenic Simulator is released only for practice purposes and it’s currently available in all countries. No real money will be exchanged in any transaction at any time. The LIVE version will be only available in the jurisdictions which are listed on Sologenic’s <a href={countriesUrl} target='_blank' rel='noopener noreferrer'>available countries</a> page.",
  _bannerSoloT: "Your email address has been successfully verified",
  _bannerSoloC:
    "You can use a full set of Simulator features. Once the LIVE version is available, you will need to pass additional verification to use it.",
  _apiKeysLimit:
    "User API keys limit exceeded. Maximum 10 active API keys allowed.",
  _changinPasswordWarningLock:
    "For your security, changing your password will put a lock on your withdrawals for 48 hours.",
  _rateLimiting: "Error: 429 Too Many Requests — You’ve been rate limited",
  _welcomeAdmin: "Welcome, {name}",
  _dashboard: "Dashboard",
  _profile: "Profile",
  _settings: "Settings",
};
